var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 3.33325H7.5L9.16667 7.49992L7.08333 8.74992C7.9758 10.5595 9.44039 12.0241 11.25 12.9166L12.5 10.8333L16.6667 12.4999V15.8333C16.6667 16.7537 15.9205 17.4999 15 17.4999C8.27304 17.0911 2.9088 11.7269 2.5 4.99992C2.5 4.07944 3.24619 3.33325 4.16667 3.33325",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 3.33325H7.5L9.16667 7.49992L7.08333 8.74992C7.9758 10.5595 9.44039 12.0241 11.25 12.9166L12.5 10.8333L16.6667 12.4999V15.8333C16.6667 16.7537 15.9205 17.4999 15 17.4999C8.27304 17.0911 2.9088 11.7269 2.5 4.99992C2.5 4.07944 3.24619 3.33325 4.16667 3.33325",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83325C13.4205 5.83325 14.1667 6.57944 14.1667 7.49992",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83325C13.4205 5.83325 14.1667 6.57944 14.1667 7.49992",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5C15.2614 2.5 17.5 4.73858 17.5 7.5",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.5C15.2614 2.5 17.5 4.73858 17.5 7.5",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.d4832138511fae99f9566b9aa9ce325f.svg";
export { ForwardRef as ReactComponent };